module.exports = require("strip-bom-stream");